import FormattedRecordTimestamp from './FormattedRecordTimestamp';

const TableFormattedTimestamp = ({
                                     record,
                                     propertyName
                                 }: { record: Record<string, unknown>, propertyName: string }) => {

    const formatOptions = {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
    } as Intl.DateTimeFormatOptions;

    return (
        <FormattedRecordTimestamp record={record} propertyName={propertyName} formatOptions={formatOptions}/>
    );

};

export default TableFormattedTimestamp;
